module.exports = __webpack_public_path__ + "img/hamburger.590f7a38.svg";